import { render, staticRenderFns } from "./ImportMenus.vue?vue&type=template&id=5aed1cd2&"
import script from "./ImportMenus.vue?vue&type=script&lang=js&"
export * from "./ImportMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports